import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HistoryInterface } from '../history/history.interface';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(private http: HttpClient) { }

  get(entityName: string, entityId: number): Observable<HistoryInterface[]> {
    return this.http.get<HistoryInterface[]>(`/${entityName}/${entityId}/history`);
  }


}
